module.exports = __webpack_public_path__ + "static/media/pagina1-cirkel_koopeenstukjebos.e8ce09c6.svg";